<template>
    <content-menu-wishlist
        :href="routewishlist"
        :display="display"
        :displayMedia="display_media"
        class="wishlist-link-menu"
    >
        <!-- <i class="far fa-heart"></i> -->
        <i :class="wishlist_icon_class"></i>
        <span class="wishlist-count">
            {{ countItemsWishlist }}
        </span>
    </content-menu-wishlist>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { CContentMenuWishlist } from "../Styles/Header/styled";

export default {
    name: "MenuWishlist",
    components: {
        "content-menu-wishlist": CContentMenuWishlist
    },
    props: {
        routewishlist: {
            default: null
        },
        display_media: {
            default: 'none'
        },
        display: {
            default: 'block'
        },
    },
    mounted() {
        if(this.user_logged) {
            this.getCountItemsWishlist()
        }
    },
    methods: {
        ...mapActions("wishlist", ["ActionGetCountItemsItemsWishlist", "setCountItemsWishlist"]),
        getCountItemsWishlist() {
            this.ActionGetCountItemsItemsWishlist()
        }
    },
    computed: {
        ...mapState("wishlist", ["countItemsWishlist"]),
        wishlist_icon_class() {
            return this.$root.$children[0].theme?.wishlist_icon_class ?? 'icon-heart'
        },
        user_logged() {
            return this.$root.$children[0].$attrs.logged
        },
    }
};
</script>
